<template>



  <h2>{{moduleData.title}}</h2>

  <template
    v-if="isLock == true"
  >
    <div
      class="w-100 vh-75 d-flex align-items-center justify-content-center bg-light-subtle"
    >
      <div
        class="text-center"
      >
        <i class="bi bi-lock-fill text-danger fs-1"></i>
        <div
          class="mt-3 text-danger fs-2"
        >
          {{moduleData.lock.message}}
        </div>
        <div
            v-if="moduleData.lock.is_unlock"
            class="text-secondary"
        >
          Nebo si ho muzete dodatecne odemknout.
          <a
            href="#"
            @click.prevent="isLock = false"
            class="link-danger"
          >
            Odemknout
          </a>

        </div>



        <display-debug>
          <template #debugView>
            moduleData: {{ moduleData.lock }}
          </template>
        </display-debug>

      </div>

    </div>





  </template>
  <template
    v-else
  >
    <form-general
        form-title="Nazev formulare"
        :form-obj="moduleData.form"
        :return-data="returnData"
        original-path="TODO odstranit original-path"
        :form-prefill="formPrefill"
    >
    </form-general>

  </template>



</template>

<script>
import FormGeneral from "@/components/general/form/FormGeneral";
import ListGeneral from "@/components/general/list/ListGeneral";
export default {
  name: "FormModule",
  components: {
    ListGeneral,
    FormGeneral,
  },
  emits: [
    "update:reloadSignal"
  ],
  props: {
    ident: {
      type: [String],
      required: false,
      default: null,
    },
    moduleData: {
      type: [Object],
      required: false,
      default: null,
    },
    returnData: {
      type: [Object, String, Number],
      required: false,
      default: null,
    },
    route: {
      type: [Object],
      required: false,
      default: null,
    },

    /*
    "ident": String,
    "moduleData": Object,
    "returnData": [Object, String, Number],
    "route": Object,
    */
    reloadSignal: {
      type: [String],
      required: false,
      default: null,
    },
    formPrefill: {
      type: [Object],
      required: false,
      default: null,
    },
    config: {
      type: [Object],
      required: false,
      default: null,
    },

    /*
        "reloadSignal": String,

        "formPrefill": [Object],
        "config": [Object],
      */

  },
  data() {
    return {
      reloadSignalBox: null,
      reloadSignalList: null,
      isLock: false,
    }
  },
  methods: {
      reloadParent(val) {
        this.$emit("update:reloadSignal", val);
      }
  },
  watch: {
    reloadSignalBox: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
    reloadSignalList: {
      handler(val) {
        this.reloadParent(val);
      },
      immediate: true
    },
  },
  created() {

  },
  mounted() {
    if(
        this.moduleData.lock
        && this.moduleData.lock.status == true
    ){
      this.isLock = true;
    }


   // console.log("dev DashboardModule mounted x")
  }
};
</script>